<template>

  <a-layout ref="layout-container" :style="{height: 'calc(100vh - 64px)'}">
    <a-layout-header class="layout-content-sub-header" v-if="attraction" v-show="collapsed">
      <div class="attraction-data">
        <span class="attraction-name">
          <strong>{{ attraction.name }}</strong>
        </span>

        <span class="attraction-id">
          Azonosító: <strong>{{ attraction.id }}</strong>
        </span>

        <span class="attraction-city" v-if="attraction.address && attraction.address.city">
        Település: <strong>{{ attraction.address.city.name }}</strong>
      </span>

        <span class="attraction-status">
          Státusz: <strong>{{ statusNames[attraction.status] }}</strong>
        </span>

        <br />

        <div class="attraction-related" v-if="attraction.relatedAttractions.length">
          Kapcsolódó események:

          <ul>
            <li v-for="relatedAttraction in attraction.relatedAttractions">
              <strong>{{ relatedAttraction.name }}</strong>

              <router-link :to="getAttractionEditUrl(relatedAttraction)">
                <a-button
                    size="small"
                    icon="edit"
                    type="primary"
                    class="action-button"
                >
                </a-button>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </a-layout-header>

    <a-layout-sider :width="300" :style="{background: 'transparent'}" :collapsible="true" v-model="collapsed">
      <NetaMultiEventDetailsMenuComponent
          class="attraction-menu-holder"
          :attraction="attraction" :collapsed="collapsed"
          :status-names="statusNames" />
    </a-layout-sider>

    <a-layout-content ref="layout-content-container" class="app-details-content">
      <transition name="slide-fade-vertical" mode="out-in">
        <router-view ref="app-layout-content" />
      </transition>
    </a-layout-content>

    <a-button
        v-show="scrolled"
        @click="scrollTop"
        class="scroll-to-top"
        size="large"
        icon="up"
        type="primary"
    />
  </a-layout>
</template>

<script>
import NetaMultiEventDetailsMenuComponent
  from '@/components/neta/neta-multi-event/NetaMultiEventDetailsMenuComponent.vue';
import store from '@/store.js';
import { REFRESH_ATTRACTION } from "@/action_types";
import { Message } from "ant-design-vue";
import { SET_LAST_GROUP_TYPE } from "@/mutation_types";

const checkAttraction = (to, from, next) => {
  let storedAttraction = store.state.attraction.current;

  if (storedAttraction && storedAttraction.id == to.params.id) {
    next();

    return;
  }

  store.dispatch({
    type: REFRESH_ATTRACTION,
    attractionId: to.params.id,
    groupType: 'event'
  }).then(() => {
    next();
  }).catch(() => {
    next({
      name: 'neta-home'
    });

    Message.error('Az esemény nem elérhető!');
  })
}

export default {
  components: {
    NetaMultiEventDetailsMenuComponent
  },

  data() {
    return {
      scrolled: false
    }
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll);

    if (this.smallScreen) {
      this.collapsed = true;
    }

    this.$store.commit({
      type: SET_LAST_GROUP_TYPE,
      groupType: 'event'
    });
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  computed: {
    attraction() {
      return this.$store.state.attraction.current;
    },

    smallScreen() {
      return window.innerWidth <= 768;
    },

    statusNames() {
      return this.$store.state.attraction.statusNames;
    },

    collapsed: {
      get() {
        return this.$store.state.attraction.sidebarCollapsed;
      },

      set(collapsed) {
        this.$store.state.attraction.sidebarCollapsed = collapsed;
      },
    }
  },

  beforeRouteEnter(to, from, next) {
    checkAttraction(to, from, next);
  },

  beforeRouteUpdate(to, from, next) {
    this.$refs['layout-content-container'].$el.scrollTop = 0;

    checkAttraction(to, from, next);
  },

  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    onScroll(e) {
      this.scrolled = window.scrollY > 0;
    },

    /**
     * @param attraction
     * @returns {string}
     */
    getAttractionEditUrl(attraction) {
      return {
        name: 'neta-basic-event-attraction-data-form',
        params: {
          id: attraction.id
        }
      }
    },
  }
}
</script>


<style lang="scss" scoped>
.scroll-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
}

.layout-content-sub-header {
  background: transparent;
  width: 100%;
  height: auto;
  line-height: 1;
  padding: 15px;

  .attraction-data {
    max-width: calc(100% - 150px);

    span {
      display: inline-block;
      margin: 5px 30px 5px 0;

      &.attraction-id,
      &.attraction-status {
        white-space: nowrap;
      }
    }
  }
}

.app-details-content {
  max-width: calc(100% - 300px);
}

.attraction-menu-holder {
  position: sticky;
  top: 0;
}

@include md {
  .ant-layout-sider {
    position: fixed;
    bottom: 0;
    background: white;
    z-index: 100;
  }

  .app-details-content {
    max-width: calc(100% - 80px);
    margin-left: 80px;
  }
}

.ant-layout {
  flex-wrap: wrap;
  overscroll-behavior-y: contain;
}

.ant-layout-content {
  padding: 15px;
}

.slide-fade-vertical-enter-active {
  transition: all 0.2s ease-in-out;
}

.slide-fade-vertical-leave-active {
  transition: all 0.2s ease-in-out;
}

.slide-fade-vertical-enter {
  transform: translateY(-50vw);
  opacity: 0
}

.slide-fade-vertical-enter-to {
  transform: translateY(0);
  opacity: 1
}

.slide-fade-vertical-leave-to {
  transform: translateY(-50vw);
  opacity: 0;
}

.attraction-related {
  a {
    margin-left: 5px;
  }
}
</style>

<style lang="scss">
label .anticon {
  margin-left: 5px;
}

.last-modification {
  margin-left: 5px;
}
</style>